import React from 'react';
import Copy from '@nib-components/copy';
import {Margin} from 'styled-components-spacing';
import {getBrandSpecificNotThePolicyHolderBody1, getBrandSpecificNotThePolicyHolderBody2} from './brandSpecificContent';

const emailOnlyLoginBrands = ['nib', 'nibnz', 'aanz', 'gu', 'cignagu'];

export function getCommonSectionsForBrand(brandConfig) {
  return [
    {
      title: "Why didn't I receive an email with a verification code?",
      children: (
        <>
          <Copy measure={false}>If you haven’t received an email with your verification code, check the following:</Copy>

          <ul>
            <li>Have you typed your email address correctly?</li>
            <li>Have you looked in your junk folder?</li>
            <li>Does your email client have a spam filter? Add the {brandConfig['emailDomain']} domain to your safelist to make sure emails from us can get through.</li>
            <li>If you’re using a work email, does your IT department use a security software to hold or monitor emails?</li>
            <li>Are you having issues receiving other emails? This could indicate a problem or delay with your email provider</li>
          </ul>
        </>
      ),
    },
    !emailOnlyLoginBrands.includes(brandConfig.brandName)
      ? {
          title: "Why didn't I receive an SMS with a verification code?",
          children: (
            <>
              <Copy measure={false}>If you haven’t received an SMS with your verification code, check the following:</Copy>

              <ul>
                <li>Have you typed your phone number correctly?</li>
                <li>Are you having issues receiving other text messages? This could indicate a problem or delay with your network provider</li>
              </ul>
            </>
          ),
        }
      : {},
    {
      title: 'Why is my verification code not working?',
      children: (
        <>
          <Copy measure={false}>If you’re unable to log in after entering the verification code you received, check the following:</Copy>

          <ul>
            <li>Have you typed your code correctly?</li>
            <li>
              Is the code valid? Your verification code expires after 15 minutes, so you’ll need to start again and get a new code if you’ve waited longer than 15 minutes to enter the first one.
            </li>
            <li>Did you close the page or hit the back button? Do not close the verification page or go back.</li>
            <li>
              Is your browser blocking cookies? If you see the error message “Something went wrong while trying to authenticate you”, check that your browser is not blocking cookies, and that you’re
              not in private mode or incognito. You may also need to clear your browsing data.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: 'Logging in if you’re not the policyholder',
      children: (
        <>
          <Copy measure={false}>{getBrandSpecificNotThePolicyHolderBody1(brandConfig)}</Copy>
          <Margin top={3}>
            <Copy measure={false}>{getBrandSpecificNotThePolicyHolderBody2(brandConfig)}</Copy>
          </Margin>
        </>
      ),
    },
    {
      title: 'Have you checked your browser and system settings?',
      children: (
        <>
          <Copy measure={false}>
            Your web browser or system settings could be impacting your ability to log in to your member account via the website. If you are having issues, try the following:
          </Copy>

          <ol>
            <li>Use a different browser (for example, Chrome, Firefox or Microsoft Edge)</li>
            <li>Make sure you're using the latest version of your browser</li>
            <li>Check that Javascript is enabled</li>
            <li>Check your browser has cookies turned on</li>
          </ol>
        </>
      ),
    },
    {
      title: 'How secure is my member account?',
      children: (
        <>
          <Copy measure={false}>
            The privacy and security of our members is our top priority, and we continue to invest in new technology to ensure greater protection of our member data. The use of One Time Passwords
            (verification codes) to access your member account is a simpler and more secure way for our members to login and access their policy information.
          </Copy>
          <Margin vertical={3}>
            <Copy measure={false}>
              Members no longer need to remember a username and password combination, which not only provides ease of access but ensures greater protection against online malicious activity.
            </Copy>
          </Margin>
        </>
      ),
    },
  ];
}
